module.exports = __webpack_public_path__ + "static/media/castel.7a80e104.jpg";